// Galerie-Nachschub.
//
// Die Produktgalerie hat zehn Dias. Luden alle sofort, waren das auf dem Handy 1,26 MB,
// die sich die Leitung mit dem Hauptbild teilten — der groesste sichtbare Inhalt war erst
// nach rund zehn Sekunden da. Jetzt laedt nur das erste Dia sofort, der Rest steht auf "lazy".
//
// Damit beim Wischen trotzdem nichts fehlt, holen wir die uebrigen Bilder hier nach — aber
// erst, wenn die Seite fertig geladen ist und der Browser nichts Wichtigeres zu tun hat.
(function () {
  'use strict';

  function nachladen() {
    var bilder = document.querySelectorAll(
      '.product-media-container img[loading="lazy"], .product-media__image[loading="lazy"]'
    );
    if (!bilder.length) return;
    // Nacheinander, nicht alle auf einmal: so bleibt Luft fuer alles andere.
    var i = 0;
    (function weiter() {
      if (i >= bilder.length) return;
      var bild = bilder[i++];
      bild.loading = 'eager';
      if (bild.complete) { weiter(); return; }
      bild.addEventListener('load', weiter, { once: true });
      bild.addEventListener('error', weiter, { once: true });
      setTimeout(weiter, 1200);   // haengt eines, geht es trotzdem weiter
    })();
  }

  function starten() {
    if ('requestIdleCallback' in window) requestIdleCallback(nachladen, { timeout: 3000 });
    else setTimeout(nachladen, 1500);
  }

  if (document.readyState === 'complete') starten();
  else window.addEventListener('load', starten);
})();

// Wischen in der Galerie auf dem Handy: genau ein Bild pro Wisch, wie bei Hallunaco.
// Vorher machte das der Browser selbst (Einrasten). Ein kraeftiges Schnippen schoss dabei ueber das
// naechste Bild hinaus - trotz scroll-snap-stop -, und ein kurzes Wischen schnappte zurueck.
// Jetzt: waagrechtes Ziehen bewegt die Bilder direkt mit dem Finger (hoechstens ein Bild weit),
// beim Loslassen geht es ein Bild weiter oder zurueck. Senkrechtes Wischen scrollt wie gewohnt
// die Seite (touch-action: pan-y in schnorv-pdp.css).
(function () {
  'use strict';

  function einrichten() {
    var galerie = document.querySelector('.product-information__media media-gallery');
    var schiene = galerie && galerie.querySelector('slideshow-slides');
    if (!schiene || schiene.dataset.sWisch) return;
    schiene.dataset.sWisch = '1';

    var startX = 0, startY = 0, startLinks = 0, startIndex = 0, modus = null;
    var letzteX = 0, aufraeumen = null;

    function breite() { return Math.max(1, schiene.clientWidth); }
    function sichtbareBilder() {
      return Array.prototype.filter.call(schiene.children, function (s) {
        return getComputedStyle(s).display !== 'none';
      }).length;
    }
    function freigeben() {
      clearTimeout(aufraeumen);
      schiene.style.removeProperty('scroll-snap-type');
      schiene.style.removeProperty('scroll-behavior');
    }

    schiene.addEventListener('touchstart', function (e) {
      if (window.innerWidth >= 750 || e.touches.length !== 1) { modus = 'aus'; return; }
      var t = e.touches[0];
      startX = letzteX = t.clientX; startY = t.clientY;
      startLinks = schiene.scrollLeft;
      startIndex = Math.round(startLinks / breite());
      modus = null;
    }, { passive: true });

    schiene.addEventListener('touchmove', function (e) {
      if (modus === 'aus' || modus === 'senkrecht') return;
      var t = e.touches[0], dx = t.clientX - startX, dy = t.clientY - startY;
      if (modus === null) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        modus = Math.abs(dx) > Math.abs(dy) ? 'waagrecht' : 'senkrecht';
        if (modus !== 'waagrecht') return;
        clearTimeout(aufraeumen);
        // waehrend des Ziehens kein Einrasten und keine weiche Animation, sonst hinkt das Bild hinterher
        schiene.style.setProperty('scroll-snap-type', 'none');
        schiene.style.setProperty('scroll-behavior', 'auto');
      }
      letzteX = t.clientX;
      var w = breite();
      schiene.scrollLeft = startLinks - Math.max(-w, Math.min(w, dx));
    }, { passive: true });

    function loslassen() {
      if (modus !== 'waagrecht') { modus = null; return; }
      modus = null;
      var w = breite(), dx = letzteX - startX, richtung = 0;
      // 30 px in eine klare Richtung reichen (so war es schon vorher gewuenscht)
      if (Math.abs(dx) >= 30) richtung = dx < 0 ? 1 : -1;
      var ziel = Math.max(0, Math.min(sichtbareBilder() - 1, startIndex + richtung));
      // Vorschaubild sofort mitnehmen, nicht erst nach dem Einrasten
      if (richtung && window.schnorvGalerieMarkieren) window.schnorvGalerieMarkieren(ziel);
      schiene.scrollTo({ left: ziel * w, behavior: 'smooth' });
      // Einrasten erst wieder einschalten, wenn die Bewegung fertig ist (Horizon gleicht dann
      // Vorschaubilder und Zaehler ueber sein eigenes scroll-Ereignis ab)
      var fertig = function () { schiene.removeEventListener('scrollend', fertig); freigeben(); };
      schiene.addEventListener('scrollend', fertig);
      aufraeumen = setTimeout(fertig, 700);
    }
    schiene.addEventListener('touchend', loslassen, { passive: true });
    schiene.addEventListener('touchcancel', loslassen, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', einrichten);
  else einrichten();
  window.addEventListener('load', einrichten);
})();
// Handy: Antippen der Bilder blaettert (linke Haelfte zurueck, rechte Haelfte weiter, wie bei Storys) statt
// zu zoomen. Horizon oeffnet den Zoom ueber on:click am Dia; ausgewertet wird das von einem Klick-Lauscher
// am document (Capture-Phase). Ein Lauscher am window kommt davor und haelt den Klick an.
// Ausserdem: Vorschaubilder sofort markieren und mittig ruecken, sobald geblaettert wird (Pfeil, Tippen,
// Wischen) - nicht erst, wenn das grosse Bild eingerastet ist.
(function () {
  'use strict';
  function teile() {
    var galerie = document.querySelector('.product-information__media media-gallery');
    if (!galerie) return null;
    return {
      galerie: galerie,
      ss: galerie.querySelector('slideshow-component'),
      schiene: galerie.querySelector('slideshow-slides'),
      leiste: galerie.querySelector('.slideshow-controls__thumbnails-container')
    };
  }
  function vorschaubilder(t) { return t.leiste ? Array.prototype.slice.call(t.leiste.querySelectorAll('.slideshow-controls__thumbnail')) : []; }
  function aktuell(t) {
    var v = vorschaubilder(t);
    for (var i = 0; i < v.length; i++) if (v[i].getAttribute('aria-selected') === 'true') return i;
    return Math.round(t.schiene.scrollLeft / Math.max(1, t.schiene.clientWidth));
  }
  // Ziel markieren und die Leiste sofort (ohne Animation) so rollen, dass es in der Mitte steht
  function markieren(t, ziel) {
    var v = vorschaubilder(t);
    if (!v.length) return;
    var n = v.length;
    ziel = t.ss && t.ss.hasAttribute('infinite') ? ((ziel % n) + n) % n : Math.max(0, Math.min(n - 1, ziel));
    v.forEach(function (x, k) { x.setAttribute('aria-selected', k === ziel ? 'true' : 'false'); });
    var a = v[ziel].getBoundingClientRect(), l = t.leiste.getBoundingClientRect();
    t.leiste.scrollBy({ left: (a.left + a.width / 2) - (l.left + l.width / 2), behavior: 'instant' });
  }
  window.schnorvGalerieMarkieren = function (ziel) { var t = teile(); if (t) markieren(t, ziel); };

  function blaettern(t, richtung) {
    markieren(t, aktuell(t) + richtung);
    if (richtung > 0 && typeof t.ss.next === 'function') t.ss.next();
    else if (richtung < 0 && typeof t.ss.previous === 'function') t.ss.previous();
    else {
      var knopf = t.galerie.querySelector('.slideshow-control--' + (richtung > 0 ? 'next' : 'previous'));
      if (knopf) knopf.click();
    }
  }

  window.addEventListener('click', function (e) {
    var ziel = e.target && e.target.closest ? e.target : null;
    if (!ziel) return;
    var t = teile();
    if (!t || !t.ss || !t.galerie.contains(ziel)) return;
    // Pfeile: Horizon blaettert selbst, wir markieren nur sofort das naechste Vorschaubild
    var pfeil = ziel.closest('slideshow-arrows .slideshow-control');
    if (pfeil) { markieren(t, aktuell(t) + (pfeil.classList.contains('slideshow-control--next') ? 1 : -1)); return; }
    if (window.innerWidth >= 750) return;
    var dia = ziel.closest('slideshow-slide');
    if (!dia || dia.querySelector('deferred-media, video, model-viewer')) return;
    e.stopPropagation();
    var r = dia.getBoundingClientRect(), richtung = e.clientX - r.left < r.width / 2 ? -1 : 1;
    aufleuchten(t, richtung);
    blaettern(t, richtung);
  }, true);

  // Rueckmeldung: die angetippte Seite leuchtet kurz auf (CSS .s-tipp-l/.s-tipp-r in schnorv-pdp.css)
  function aufleuchten(t, richtung) {
    var rahmen = t.schiene && t.schiene.parentElement;
    if (!rahmen) return;
    rahmen.classList.remove('s-tipp-l', 's-tipp-r');
    void rahmen.offsetWidth;   // Animation neu starten, auch bei schnellem Doppeltippen
    rahmen.classList.add(richtung < 0 ? 's-tipp-l' : 's-tipp-r');
    clearTimeout(rahmen.sTippTimer);
    rahmen.sTippTimer = setTimeout(function () { rahmen.classList.remove('s-tipp-l', 's-tipp-r'); }, 400);
  }

  // Wisch-Hinweis (Bilder rutschen beim ersten Anzeigen kurz nach links) am 01.11.2026 auf Wunsch entfernt
})();
// Vorschaubilder laufen beim Wischen mit. Horizon richtet die Leiste nur aus, wenn man ein Vorschaubild
// antippt, beim Wischen der grossen Bilder nicht. Mit 3½ sichtbaren Vorschaubildern blieb das markierte
// ab Bild 5 ausserhalb der Leiste. Jetzt wird das markierte (aria-selected) in die Mitte gerollt - auch am PC,
// seit die Vorschaubilder dort 88 px gross sind und nicht mehr alle in die Leiste passen.
(function () {
  'use strict';
  function einrichten() {
    var leiste = document.querySelector('.product-information__media .slideshow-controls__thumbnails-container');
    if (!leiste || leiste.dataset.sMitlauf) return;
    leiste.dataset.sMitlauf = '1';
    var warte = null;
    function ausrichten() {
      var aktiv = leiste.querySelector('.slideshow-controls__thumbnail[aria-selected="true"]');
      if (!aktiv || aktiv.offsetWidth === 0) return;
      var a = aktiv.getBoundingClientRect(), l = leiste.getBoundingClientRect();
      var versatz = (a.left + a.width / 2) - (l.left + l.width / 2);
      if (Math.abs(versatz) > 2) leiste.scrollBy({ left: versatz, behavior: 'smooth' });
    }
    new MutationObserver(function () { clearTimeout(warte); warte = setTimeout(ausrichten, 60); })
      .observe(leiste, { attributes: true, subtree: true, attributeFilter: ['aria-selected'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', einrichten);
  else einrichten();
  window.addEventListener('load', einrichten);
})();
